import { EMPLOYEE_BASE_URL } from "src/redux/api/appConst";
import { axiosAuth } from "src/redux/api/common";
import { ResignationResponse } from "../resignation.types";

export const getResignation = async () => {
  const api = axiosAuth(EMPLOYEE_BASE_URL);

  const { data } = await api.get(`/resignations`);

  return data.data.resignations;
};

export const resignationResponse = async ({
  id,
  employeeId,
  response,
}: {
  id: string;
  employeeId: number;
  response: ResignationResponse;
}) => {
  const api = axiosAuth(EMPLOYEE_BASE_URL);

  const { data } = await api.patch(`/resignation/${id}`, {
    employee_id: employeeId,
    status: response,
  });

  return data.data;
};
